function $(selector = "", context = document) {
  return context.querySelector(selector);
}

function $$(selector = "", context = document) {
  return Array.prototype.slice.call(context.querySelectorAll(selector));
}

export { $, $$ };
